import { createAction, props } from '@ngrx/store';
import { ApiError } from '@hrra/core';
import { ActionPayload } from "@hrra/core";
import { Industry } from '@hrra/common-models';
import { IndustryListItem } from 'src/app/shared/models/industry-model';

export enum Actions {
    GetJobseekerIndustryList = '[Jobseeker profile] Get jobseeker industry list',
    GetJobseekerIndustryListSuccess = '[Jobseeker profile] Get jobseeker industry list success',
    GetJobseekerIndustryListFail = '[Jobseeker profile] Get jobseeker industry list fail',
}

export const getJobseekerIndustryList = createAction(
    Actions.GetJobseekerIndustryList
);

export const getJobseekerIndustryListSuccess = createAction(
    Actions.GetJobseekerIndustryListSuccess,
    props<ActionPayload<IndustryListItem[]>>()
);

export const getJobseekerIndustryListFail = createAction(
    Actions.GetJobseekerIndustryListFail,
    props<ActionPayload<ApiError>>()
); 